import { styled } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';

export const TitleFieldCard = styled(SRoundedContainer)({
  width: '100%',
  border: 'none',
  padding: '12px 16px',
  boxSizing: 'border-box'
});
